import React from 'react';
import { Button, SimpleForm, SelectInput, NumberInput } from 'react-admin';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

export class MetricFilterComponent extends React.Component {
    constructor() {
      super();
      this.state = {
        data: [] /* metric:"impressions", operator:"gt", value */
      };
      // window.setInterval(()=>{console.log('===>METRIC FILTER STATE:', this.state);}, 10000);
    }
    addMetric = () => {
      this.setState({
        data: this.state.data.concat([{ metric:'', operator:'' }])
      });
    };
    removeMetric = idx => () => {
      this.setState({
        data: this.state.data.filter((s, sidx) => idx !== sidx)
      });
    };
    random = () => { return Math.floor(Math.random()*9999999); }
    updateMetric = idx => event => {
      const newData = this.state.data.map((item, sidx) => {
        if (idx !== sidx) return item;
        let name = event.target.name;
        name = name.substring(0, name.indexOf('-'));
        item[name] = (name!=='value')?event.target.value:Number(event.target.value);
        return item;
      });
      this.setState({ data: newData });
    };
    render() {
      return (
        <div style={{width: '100%'}}>
          <div style={{float: 'left', width: '100%'}}>
            <div style={{float: 'left'}}><h4>Filter Metrics</h4></div>
            <div style={{float: 'left', paddingLeft: '30px', paddingTop: '18px'}}><Button onClick={this.addMetric} color='primary' label='Add Filter' startIcon={<AddCircleOutlineIcon />} /></div>
          </div>
          <SimpleForm toolbar={null}>
          {this.state.data.map((item, idx) => (
            <div key={idx} style={{float: 'left', width: '100%'}}>
              <div style={{float: 'left'}}>
                <SelectInput key={idx} source={'metric-'+this.random()} defaultValue={item.metric} label="Select Metric" 
                  choices={this.props.metricChoices} onChange={this.updateMetric(idx)} />
              </div>
              <div style={{float: 'left', paddingLeft:'5px'}}>
                <SelectInput source={'operator-'+this.random()} defaultValue={item.operator} label="Is" 
                  choices={[{ id: 'eq', name: 'Equals' },{ id: 'gt', name: 'Greater than' },{ id: 'lt', name: 'Less than' }]} 
                  onChange={this.updateMetric(idx)}
                />
              </div>
              <div style={{float: 'left', paddingLeft:'5px'}}>
                <NumberInput source={'value-'+this.random()} defaultValue={item.value} label="Value" onChange={this.updateMetric(idx)} />
              </div>
              <div style={{float: 'left', paddingLeft:'5px', paddingTop: '18px'}}>
                <Button color='secondary' label='remove' onClick={this.removeMetric(idx)} startIcon={<HighlightOffIcon />} />
              </div>
            </div>
          ))}
          </SimpleForm>
        </div>
      );
    }
  }